import React from "react";
import { Media } from "reactstrap"

class CollapseImg extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            collapsed: true,
            showToggleBtn: false,
        }
    }

    toggle = () => {
        this.setState({ collapsed: !this.state.collapsed })
    }

    render() {
        const { containerStyle, width, collapsedHeight, src } = this.props;

        const { collapsed, showToggleBtn } = this.state;

        return (
            <div style={containerStyle}>
                <Media style={collapsed ? { height: collapsedHeight, overflow: "hidden" } : {}}>
                    <img src={src} style={{ borderBottomLeftRadius: 10, borderBottomRightRadius: 10, width: width }} onLoad={({ target }) => {

                        if (target.height > collapsedHeight) {
                            this.setState({ collapsed: true, showToggleBtn: true })
                        } else {
                            this.setState({ collapsed: false })
                        }
                    }} />
                </Media>
                {showToggleBtn && (
                    <div style={{ marginTop: 10, width: "100%", backgroundColor: "#DCDCDC", textAlign: "center", borderBottomLeftRadius: 10, borderBottomRightRadius: 10 }}
                        onClick={(e) => {
                            this.toggle();
                            e.stopPropagation();
                        }}>
                        {collapsed ?
                            <i className="ni ni-bold-down" style={{ fontSize: 25 }} />
                            :
                            <i className="ni ni-bold-up" style={{ fontSize: 25 }} />
                        }
                    </div>
                )}
            </div>
        );
    }
}

export default CollapseImg;